<div id="body" class="section center nomargin">
    <h2 class="title">{{pageTitleA}} <span class="subtitle" [style]="getCssColor()"  (click)="goToPage()">{{pageTitleB}}</span></h2>
    <span>{{pageSubtitle}}</span>
</div>